"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigureSoundBite = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const store_1 = require("../../store");
const document_1 = require("../../slices/document");
const useDevice_1 = require("../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const useDocument_1 = __importDefault(require("../../hooks/useDocument"));
const document_2 = require("../../services/document");
const colors_1 = require("../../common/colors");
const GradientButton_1 = require("../GradientButton");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const AppText_1 = require("../AppText");
const ScrollCustomIndicator_1 = __importDefault(require("../ScrollCustomIndicator"));
const GenericChip_1 = require("../AppCharacter/GenericChip");
const AppLoader_1 = __importDefault(require("../AppLoader"));
;
const ConfigureSoundBite = ({ document }) => {
    const { isWebDevice, isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { request } = (0, useRequest_1.default)();
    const { followDocument } = (0, useDocument_1.default)();
    const [config, setConfig] = (0, react_1.useState)({
        duration: { key: 'short', words: 450 },
        tone: { preset: ['Educational', 'Playful'], /* custom: '' */ },
        personality: { host: 'Inquisitive', guest: 'Quirky' },
        focus: '',
        language: 'English'
    });
    const [isConfigurationPending, setIsConfigurationPending] = (0, react_1.useState)(false);
    const [focusValue, setFocusValue] = (0, react_1.useState)('');
    const durations = [
        { key: 'short', words: 450, label: 'Bite-Sized' },
        { key: 'medium', words: 786, label: 'Balanced' },
        { key: 'long', words: 1280, label: 'Deep Dive' },
    ];
    const tones = [
        { value: 'Educational', emoji: '📚' },
        { value: 'Amazed', emoji: '🤩' },
        { value: 'Combative', emoji: '💪' },
        { value: 'Playful', emoji: '😄' },
        { value: 'Reverent', emoji: '🙏' }
    ];
    // Map friendly personalities to functional roles
    const hostPersonalityToRole = {
        'Confident': 'thesis presenter',
        'Inquisitive': 'main summarizer',
        'Thoughtful': 'expert analyst',
        'Playful': 'engaging narrator',
        'Sarcastic': 'critical reviewer'
    };
    const guestPersonalityToRole = {
        'Empathetic': 'active listener',
        'Combative': 'counterargument provider',
        'Amazed': 'enthusiastic learner',
        'Quirky': 'creative questioner',
        'Balanced': 'objective analyzer'
    };
    const deviceWidth = isWebDevice ? window.innerWidth : react_native_1.Dimensions.get('window').width;
    const hostPersonalities = Object.keys(hostPersonalityToRole);
    const guestPersonalities = Object.keys(guestPersonalityToRole);
    const handleSaveConfiguration = (0, react_1.useCallback)(() => {
        if ('shareId' in document) {
            followDocument(document.shareId);
            setIsConfigurationPending(true);
        }
        else {
            dispatch((0, document_1.toggleAudioConfigOpen)());
            dispatch((0, document_1.patchDocument)({
                id: document.character_id,
                changes: {
                    isPodcastGenerating: 'Y',
                }
            }));
            request(document_2.podcastfy, document, {
                wordsCount: config.duration.words,
                conversationStyle: config.tone.preset,
                hostRole: hostPersonalityToRole[config.personality.host],
                guestRole: guestPersonalityToRole[config.personality.guest],
                // userInstructions: focusValue
            }).then((response) => {
                if (!response) {
                    dispatch((0, document_1.patchDocument)({
                        id: document.character_id,
                        changes: {
                            isPodcastGenerating: 'N',
                        }
                    }));
                }
            });
        }
    }, [document, config, focusValue, followDocument, request, dispatch]);
    (0, react_1.useEffect)(() => {
        if (isConfigurationPending && !('shareId' in document)) {
            handleSaveConfiguration();
            setIsConfigurationPending(false);
        }
    }, [isConfigurationPending, document, handleSaveConfiguration]);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.Modal, { transparent: true, visible: true, animationType: "slide", children: [(0, jsx_runtime_1.jsx)(AppLoader_1.default, { showLoader: true, isLoading: isConfigurationPending }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalOverlay, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [
                        styles.modalContent,
                        isWebDevice && styles.webContainer,
                        isMobileScreen && styles.mobileContainer,
                    ], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.header, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [
                                                styles.title,
                                                deviceWidth < 360 && { fontSize: 14 },
                                                deviceWidth >= 360 && deviceWidth < 400 && { fontSize: 18 },
                                                deviceWidth >= 400 && { fontSize: 20 }
                                            ], children: "Customize SoundBite" }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [
                                                { color: colors_1.Colors.DARK_100 },
                                                deviceWidth < 360 && { fontSize: 13 },
                                                deviceWidth >= 360 && deviceWidth < 390 && { fontSize: 14 },
                                                deviceWidth >= 390 && { fontSize: 15 }
                                            ], children: "How do you want to create your podcast?" })] }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClose: () => dispatch((0, document_1.toggleAudioConfigOpen)()), buttonSize: 32, verticalOffset: -10, inPlace: true })] }), (0, jsx_runtime_1.jsxs)(ScrollCustomIndicator_1.default, { style: styles.scrollContainer, showsVerticalScrollIndicator: false, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.section, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.sectionTitle, children: "Length" }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.lengthContainer, children: durations.map((duration) => ((0, jsx_runtime_1.jsx)(GenericChip_1.GenericChip, { leftContent: { type: 'text', value: duration.label }, selected: config.duration.key === duration.key, onPress: () => setConfig({ ...config, duration }) }, duration.key))) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.section, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.sectionTitle, children: "Tone" }), (0, jsx_runtime_1.jsx)(ScrollCustomIndicator_1.default, { horizontal: true, showsHorizontalScrollIndicator: true, style: styles.toneScrollContainer, contentContainerStyle: [
                                                styles.toneContainer,
                                                isMobileScreen && styles.toneContainerMobile,
                                                !isMobileScreen && styles.toneContainerWeb
                                            ], children: tones.map(tone => {
                                                const isSelected = config.tone.preset.includes(tone.value);
                                                return ((0, jsx_runtime_1.jsx)(GenericChip_1.GenericChip, { leftContent: { type: 'emoji', value: tone.emoji }, rightContent: tone.value, selected: isSelected, onPress: () => setConfig({
                                                        ...config,
                                                        tone: {
                                                            ...config.tone,
                                                            preset: isSelected
                                                                ? config.tone.preset.filter((preset) => preset !== tone.value)
                                                                : [...config.tone.preset, tone.value]
                                                        }
                                                    }) }, tone.value));
                                            }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: isMobileScreen ? 'column' : 'row', gap: 16 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.sectionTitle, children: "Host Personality" }), (0, jsx_runtime_1.jsx)(native_base_1.Select, { selectedValue: config.personality.host, minWidth: "200", minHeight: "44px", borderColor: colors_1.Colors.DARK_600, borderWidth: 1, backgroundColor: colors_1.Colors.DARK_700, color: colors_1.Colors.white, accessibilityLabel: "Select Host Personality", placeholder: "Select Host Personality", onValueChange: (itemValue) => {
                                                            setConfig({
                                                                ...config,
                                                                personality: { ...config.personality, host: itemValue }
                                                            });
                                                        }, dropdownIcon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronDown, color: colors_1.Colors.white, style: { marginRight: 12 } }), _selectedItem: {
                                                            bg: colors_1.Colors.DARK_700,
                                                            color: colors_1.Colors.white,
                                                        }, children: hostPersonalities.map((personality) => ((0, jsx_runtime_1.jsx)(native_base_1.Select.Item, { label: personality, value: personality }, personality))) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.sectionTitle, children: "Guest Personality" }), (0, jsx_runtime_1.jsx)(native_base_1.Select, { selectedValue: config.personality.guest, minWidth: "200", minHeight: "44px", borderColor: colors_1.Colors.DARK_600, borderWidth: 1, backgroundColor: colors_1.Colors.DARK_700, color: colors_1.Colors.white, accessibilityLabel: "Select Guest Personality", placeholder: "Select Guest Personality", onValueChange: (itemValue) => {
                                                            setConfig({
                                                                ...config,
                                                                personality: { ...config.personality, guest: itemValue }
                                                            });
                                                        }, dropdownIcon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronDown, color: colors_1.Colors.white, style: { marginRight: 12 } }), _selectedItem: {
                                                            bg: colors_1.Colors.DARK_700,
                                                            color: colors_1.Colors.white,
                                                        }, children: guestPersonalities.map((personality) => ((0, jsx_runtime_1.jsx)(native_base_1.Select.Item, { label: personality, value: personality }, personality))) })] })] }) })] }), (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: "Create SoundBite", fullWidth: true, style: styles.saveButton, onPress: handleSaveConfiguration })] }) })] }));
};
exports.ConfigureSoundBite = ConfigureSoundBite;
const styles = react_native_1.StyleSheet.create({
    modalOverlay: {
        flex: 1,
        backgroundColor: `${colors_1.Colors.DARK_700}80`,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        width: '100%',
        maxHeight: '90%',
        borderRadius: 12,
        position: 'relative',
        maxWidth: 600,
        backgroundColor: colors_1.Colors.DARK_600,
    },
    webContainer: {
        maxWidth: 600,
        padding: 24,
    },
    mobileContainer: {
        padding: 16,
        width: '100%',
    },
    scrollContainer: {
        flex: 1,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 24,
    },
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 24,
        height: 24,
    },
    toneEmojiText: {
        fontSize: 16,
        textAlign: "center",
        width: 20
    },
    toneScrollContainer: {
        flexDirection: 'row'
    },
    toneContainerWeb: {
        flexDirection: 'row'
    },
    lengthChipText: {
        fontSize: 14,
        color: colors_1.Colors.white,
        textAlign: 'center'
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        color: colors_1.Colors.white,
    },
    section: {
        marginBottom: 24,
    },
    sectionTitle: {
        fontSize: 16,
        color: colors_1.Colors.white,
        marginBottom: 12,
    },
    lengthContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    lengthChip: {
        flex: 1,
        borderRadius: 30,
        backgroundColor: colors_1.Colors.DARK_700,
        borderColor: colors_1.Colors.DARK_600,
        borderWidth: 1,
        paddingHorizontal: 16,
        paddingVertical: 8,
        margin: 4,
        alignItems: 'center',
        justifyContent: 'center',
    },
    selectedLengthChip: {
        backgroundColor: colors_1.Colors.PRIMARY_700,
        borderColor: colors_1.Colors.PRIMARY_300,
    },
    hoveredChip: {
        backgroundColor: colors_1.Colors.PRIMARY_700,
    },
    toneContainer: {
        flexDirection: 'row',
        marginBottom: 12,
    },
    toneContainerMobile: {
        flexWrap: 'wrap',
    },
    toneChip: {
        borderRadius: 30,
        backgroundColor: colors_1.Colors.DARK_700,
        borderColor: colors_1.Colors.DARK_600,
        borderWidth: 1,
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 16,
        paddingVertical: 8,
        gap: 8,
        margin: 4,
    },
    selectedToneChip: {
        backgroundColor: colors_1.Colors.PRIMARY_700,
        borderColor: colors_1.Colors.PRIMARY_300,
    },
    toneChipText: {
        color: colors_1.Colors.white,
        fontSize: 14,
    },
    customToneContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    inputWithIcon: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: colors_1.Colors.DARK_700,
        borderRadius: 8,
        paddingRight: 12,
    },
    input: {
        flex: 1,
        color: colors_1.Colors.white,
        padding: 12,
        fontSize: 14,
    },
    textArea: {
        height: 100,
        textAlignVertical: 'top',
        backgroundColor: colors_1.Colors.DARK_700,
        borderRadius: 8,
    },
    marginTop: {
        marginTop: 16,
    },
    saveButton: {
        height: 48,
        borderRadius: 8,
        marginTop: 8,
        marginBottom: 16,
    }
});
exports.default = exports.ConfigureSoundBite;
